import { render } from "./BackorderNotePopUp.vue?vue&type=template&id=2e928508"
import script from "./BackorderNotePopUp.vue?vue&type=script&lang=js"
export * from "./BackorderNotePopUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__